import { CDN_URL } from '@karma/utils/constants/env';

export const DEFAULT_TRENDING = `${CDN_URL}/images/error-images/shop_1100x500.png`;
export const DEFAULT_CASHBACK = `${CDN_URL}/images/error-images/shop_800x500.png`;
export const DEFAULT_NEW_SALES = `${CDN_URL}/images/error-images/shop_1100x915.png`;
export const DEFAULT_FEATURED = `${CDN_URL}/images/error-images/shop_1100x600.png`;
export const DEFAULT_SEO_TAG = `${CDN_URL}/images/error-images/card_800x760.png`;
export const DEFAULT_TAG = `${CDN_URL}/images/error-images/card_800x1000.png`;
export const DEFAULT_KARMA_EARN_OFFER_LOGO = `${CDN_URL}/images/error-images/karma_earn_offer_logo.png`;
export const KARMA_EARN_SURVEY_CARD_IMAGE = `${CDN_URL}/images/karma/icons/survey-card.png`;
